// Ce que la fiche d'offre montre, selon la formule (issue #76).
//
// LES DEUX FICHES NE RÉPONDENT PAS À LA MÊME QUESTION. En console, un business
// manager choisit LEQUEL de ses profils présenter : la liste des candidats, la
// comparaison et le détail du score à la demande sont l'écran lui-même. En
// Radar, un particulier se demande s'il postule : de quoi parle le poste,
// pourquoi ce score, qu'est-ce qui lui manque. Un bloc « Candidats » d'une
// seule entrée (soi-même), un « 1 profil évalué », deux catégories ESCO
// dépliées et le journal occupaient la place de ces trois réponses.
//
// Décidé ICI, en une fonction pure, plutôt que par des `profilUnique &&`
// éparpillés dans le JSX : c'est ce qui permet au test de vérifier les deux
// formules à la fois (règle de apps/console/CLAUDE.md, une régression de la
// console passe sinon inaperçue derrière un test écrit pour Radar).

import type { Formule } from './formule'

export interface PresentationFiche {
  /** Une colonne (score, action, description, coulisses) au lieu des deux
   *  colonnes candidats / analyse. */
  uneColonne: boolean
  /** Le détail du score (dimensions, atouts, écarts) affiché d'office, sans
   *  bouton « Détail ». */
  scoreDeplie: boolean
  /** La description ouverte d'office, sans bouton pour la déplier. */
  descriptionDepliee: boolean
  /** Le bloc « Candidats » et la puce « N profils évalués ». */
  candidats: boolean
  /** Le sélecteur de tri en haut à droite (À décider / À revoir / Écartée).
   *  En Radar, le bloc d'action le remplace : deux commandes pour la même
   *  décision obligeaient à lire les deux pour savoir où on en était. */
  selecteurStatut: boolean
  /** Catégories et journal dans un repli fermé par défaut, plutôt qu'en
   *  colonne. Le journal reste la source de vérité des statuts : on le
   *  replie, on ne le retire pas. */
  coulissesRepliees: boolean
  /** Le badge « Emploi / Mission » près de l'employeur. Radar ne suit que des
   *  employeurs : « Emploi » sur chaque fiche ne disait rien (issue #168). */
  badgeGenre: boolean
  /** « Ce que l'offre demande » ouvert d'office : c'est la réponse à « qu'est-
   *  ce qu'ils veulent », qu'on ne pensait pas à déplier (issue #168). Coûte
   *  un appel IA à la première ouverture de chaque fiche. */
  exigencesOuvertes: boolean
  /** Le retour sur le score en lien nommé plutôt qu'en pouces emoji. */
  avisEnLien: boolean
  /** L'avis résumé en tête (palier, CV adapté, « Pour vous », « À vérifier »),
   *  les exigences sous l'action, et le panneau de score replié sous « Le
   *  détail du score » (issue #169). */
  avisResume: boolean
  /** L'annonce dans un repli « L'annonce complète » : au téléphone, elle
   *  faisait huit écrans sous l'action (issue #169). */
  annonceRepliee: boolean
}

export function presentationFiche(formule: Formule): PresentationFiche {
  const radar = formule === 'radar'
  return {
    uneColonne: radar,
    scoreDeplie: radar,
    descriptionDepliee: radar,
    candidats: !radar,
    selecteurStatut: !radar,
    coulissesRepliees: radar,
    badgeGenre: !radar,
    exigencesOuvertes: radar,
    avisEnLien: radar,
    avisResume: radar,
    annonceRepliee: radar,
  }
}
